import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled.section`
  display: grid;
  gap: 8px;
`

const DatFolderTitle = styled.button<{ $isHidden: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.54);
  color: #f8fafc;
  text-align: left;
  font-size: 0.82rem;
  font-weight: 620;
  transition:
    border-color 160ms ease,
    background 160ms ease;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    flex: 0 0 8px;
    border-right: 1.5px solid rgba(226, 232, 240, 0.72);
    border-bottom: 1.5px solid rgba(226, 232, 240, 0.72);
    transform: ${props => (props.$isHidden ? 'rotate(45deg)' : 'rotate(-135deg)')};
    transition: transform 160ms ease;
  }

  &:hover {
    border-color: rgba(148, 163, 184, 0.18);
    background: rgba(15, 23, 42, 0.66);
  }
`

const Content = styled.div<{ $isHidden: boolean }>`
  display: ${props => (props.$isHidden ? 'none' : 'grid')};
  gap: 8px;
`

type Props = {
  title: string
  defaultHidden?: boolean
  children?: React.ReactNode
}

export const DatFolder = (props: Props) => {
  const [isHidden, setHidden] = React.useState(props.defaultHidden == null ? false : props.defaultHidden)

  return (
    <Wrapper>
      <DatFolderTitle type="button" $isHidden={isHidden} onClick={() => setHidden(!isHidden)}>
        {props.title}
      </DatFolderTitle>

      <Content $isHidden={isHidden}>{props.children}</Content>
    </Wrapper>
  )
}
